module.exports = __webpack_public_path__ + "img/target_symbol_blue.2c7649fd.svg";